import React, { useEffect } from 'react'
import { Route, useLocation, useHistory, Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import { getCleanUrlReferral } from '../../helpers'

const RouteLayout = ({
  isAuthenticated, 
  authLayout: AuthLayout, 
  guestLayout: GuestLayout, 
  component: Component, 
  requireAuth = false,
  ...rest 
}) => {
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    getCleanUrlReferral(location, history)
  }, [location.pathname, location.search, history])

  const token = localStorage.getItem('nabawi-token')
  const isUserAuthenticated = Boolean(isAuthenticated || token)

  return (
    <Route
      {...rest}
      render={(matchProps) => {
        if (requireAuth && !isUserAuthenticated) {
          return <Redirect to="/" />
        }

        if (isUserAuthenticated) {
          return (
            <AuthLayout>
              <Component {...matchProps} />
            </AuthLayout>
          )
        }

        return (
          <GuestLayout>
            <Component {...matchProps} />
          </GuestLayout>
        )
      }}
    />
  )
}

RouteLayout.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  component: PropTypes.any.isRequired,
  authLayout: PropTypes.any.isRequired,
  guestLayout: PropTypes.any.isRequired,
  requireAuth: PropTypes.bool,
  path: PropTypes.string
}

export default RouteLayout
